import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import swal from 'sweetalert2';
import { getHttpErrorCode } from './http-error.util';

@Injectable()
export class NotificationService {
  private readonly httpClient = inject(HttpClient);
  private store: any;
  private readonly baseConfig = {};

  constructor() {
    this.loadStore();
  }

  loadStore() {
    this.httpClient
      .get('assets/msgs.json')
      .subscribe((data) => (this.store = data));
  }

  debug(text: any, args = []) {
    let message: string = this.interpolate(text, args);
    swal.fire({
      title: '',
      html: message,
      icon: 'error',
      ...this.baseConfig,
    });
  }

  error(ex: any | HttpErrorResponse, args = []) {
    const code = this.getErrorCode(ex);

    const msgEntry = this.findKey(code);
    if (!msgEntry) {
      console.error(ex);
      return;
    }

    let message: string = this.interpolate(msgEntry.msg, args);
    swal.fire({
      title: '',
      html: message,
      icon: 'error',
      ...this.baseConfig,
    });
  }

  success(key: string, args: any[] = []) {
    const msgEntry = this.findKey(key);
    if (!msgEntry) {
      return;
    }

    let message: string = this.interpolate(msgEntry.msg, args);
    swal.fire({
      title: '',
      html: message,
      icon: 'success',
      ...this.baseConfig,
    });
  }

  info(key: string, args: any[] = []) {
    const msgEntry = this.findKey(key);
    if (!msgEntry) {
      return;
    }

    const message: string = this.interpolate(msgEntry.msg, args);
    swal.fire({
      title: '',
      html: message,
      icon: 'info',
      ...this.baseConfig,
    });
  }

  close(): void {
    swal.close();
  }

  askFor(key: string, args: any[] = []): Promise<any> {
    const msgEntry = this.findKey(key);
    let message: string = this.interpolate(msgEntry.msg, args);

    return swal.fire({
      title: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Claro que si!',
      cancelButtonText: 'No ahora',
      allowOutsideClick: false,
      ...this.baseConfig,
    });
  }

  private interpolate(message: string, args: any[]) {
    args.forEach((value) => {
      message = message.replace(value.key, value.val);
    });

    return message;
  }

  private findKey(key: string) {
    return this.store.find((st: any) => st.code === key);
  }

  private getErrorCode(ex: any) {
    if (ex instanceof HttpErrorResponse) {
      return getHttpErrorCode(ex.error);
    }

    return getHttpErrorCode(ex);
  }
}
